import log from '@/core/logging.service';
import { router } from '@/core/router';
import { LinkModel } from '@/types/B2BcontentServerContract';
import { getRouteQueryFromFullPath } from '@/core/browser/route-query.composable';

export function hardReload() {
    log.info('Hard reload');
    window.location.reload();
}

export function softRedirect(url: string, replace: boolean = true) {
    log.info(`Soft redirect. Url: ${url}, Replace: ${replace}`);
    const query = getRouteQueryFromFullPath(url);
    const method = replace ? 'replace' : 'push';
    router[method]({ path: url, query });
}

export function hardRedirect(url: string, replace: boolean = false) {
    log.debug(`Hard redirect. Url: ${url}, Replace: ${replace}`);
    if (replace) {
        window.location.replace(url);
    } else {
        window.location.href = url;
    }
}

export function maybeSoftRedirect(link: LinkModel, replace?: boolean) {
    if (link.spaLink) {
        softRedirect(link.url, replace);
    } else {
        hardRedirect(link.url, replace);
    }
}
